import Vue from 'vue';

import * as types from './mutation-types';

const mutations = {
  [types.SET_QUIZ_RESULT](state, { quizResult, pageId }) {
    Vue.set(state.catQuizResults, pageId, quizResult);
  },

  [types.SET_QUIZ_RESULTS](state, { quizResults }) {
    const quizResultsWithPosition = quizResults.map((result, index) => ({
      ...result,
      position: index + 1,
    }));

    Vue.set(state, 'catQuizResults', quizResultsWithPosition);
  },

  [types.SET_CAT_QUIZ_REWARD_TYPE](state, { rewardType }) {
    Vue.set(state, 'rewardType', rewardType);
  },

};

export default mutations;
